import * as React from "react";
import { useState } from "react";
import "./TabsGroup.scss";

interface TabsGroupsProps {
  tabs: string[];
  contentArray: React.ReactNode[];
}

const TabsGroup = (props: TabsGroupsProps) => {
  const { tabs, contentArray } = props;
  const [currentTab, setCurrentTab] = useState<number>(0);

  return (
    <div>
      <div className="generic-tabs">
        <div className="tabs-header h-flex">
          {tabs.map((tab, index) => (
            <div
              key={index}
              className={`generic-tabs__tab ${index === currentTab ? "generic-tabs__tab--active" : ""}`}
              onClick={() => setCurrentTab(index)}
            >
              {tab}
            </div>
          ))}
        </div>
      </div>
      <div className="tab-content">
        <div>{contentArray[currentTab]}</div>
      </div>
    </div>
  );
};

export default TabsGroup;
